import { AlertTriangle, Target } from "lucide-react";

const RisksTab = ({ risksData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Risk Register</h3>
                <p className="text-sm text-slate-500 mt-1">Identified threats, vulnerabilities, and their potential business impact.</p>
              </div>
            <div className="grid grid-cols-1 gap-4">
              {risksData.map((risk) => (
                <div key={risk.id} className="bg-white rounded-2xl ring-1 ring-slate-200/60 shadow-sm hover:shadow-md transition-all flex flex-col sm:flex-row overflow-hidden group">
                  <div className={`w-2 sm:w-2 shrink-0 bg-${risk.color}-500`}></div>
                  <div className="p-6 flex-1 flex flex-col justify-between">
                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-6">
                      <div className="space-y-2">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="text-xs font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-md tracking-wider">{risk.id}</span>
                          <span className="text-xs font-bold text-indigo-700 bg-indigo-50 ring-1 ring-indigo-200/50 px-2.5 py-1 rounded-md flex items-center gap-1.5"><Target size={12} /> {risk.system}</span>
                        </div>
                        <h4 className="text-lg font-bold text-slate-900 leading-tight">{risk.title}</h4>
                      </div>
                      <span className={`shrink-0 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full bg-${risk.color}-50 text-${risk.color}-700 ring-1 ring-${risk.color}-200/60 flex items-center gap-1.5 h-fit`}>
                        <AlertTriangle size={14} /> {risk.severity} Severity
                      </span>
                    </div>
                    
                    <div className="flex items-center gap-6 bg-slate-50 p-3.5 rounded-xl border border-slate-100">
                      <div className="flex items-center gap-2 text-sm">
                        <span className="font-bold text-slate-400 uppercase tracking-widest text-[10px]">Likelihood</span>
                        <span className="font-semibold text-slate-800">{risk.likelihood}</span>
                      </div>
                      <div className="w-px h-4 bg-slate-200"></div>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="font-bold text-slate-400 uppercase tracking-widest text-[10px]">Impact</span>
                        <span className="font-semibold text-slate-800">{risk.impact}</span>
                      </div>
                      <div className="w-px h-4 bg-slate-200"></div>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="font-bold text-slate-400 uppercase tracking-widest text-[10px]">Status</span>
                        <span className="font-semibold text-slate-800 flex items-center gap-1.5">
                          <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse"></span> {risk.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default RisksTab;